<template>
  <b-modal id="comment-modal" v-model="isOpen" centered hide-footer hide-header @close="isOpen = false">
    <div class="m-comment">
      <svg-icon class="modal-dialog__close" size="8" name="times-bold" @click="close" />

      <div class="m-comment__text">{{ text }}</div>
    </div>
  </b-modal>
</template>

<script>
import SvgIcon from "@/components/svg-icon";

export default {
  name: "m-comment",
  components: {
    "svg-icon": SvgIcon,
  },
  data() {
    return {
      isOpen: false,
      text: "",
    };
  },
  methods: {
    open(text) {
      this.text = text;
      this.isOpen = true;
    },
    close() {
      this.isOpen = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.m-comment {
  &__text {
    font-size: 13px;
  }
}
</style>

<style lang="scss">
#comment-modal {
  .modal-content {
    height: auto;
  }
}
</style>
